<template lang="pug">
  .desktop-teacher
    v-row
      v-col(cols=12 md=4)
        v-card(
          flat
        ).sdo-radius.mt-10.mb-5.widget.widget--lead.sdo-shadow
          v-avatar(color="secondary" size=80).ml-5.mt-n10
            v-icon(color="grey lighten-4" large) mdi-human-male-board
          v-card-text.px-5
            div
              h3.secondary--text Ведение курсов
              p Вы ведете 5 курсов
            div: v-btn(
              color="secondary"
              depressed
              :to="{ name: 'EducationCoursesTelegramChannels' }"
            ).mb-2
              v-icon(left) $telegram
              span Чаты
            div: v-btn(
              color="secondary"
              depressed
              :to="{ name: 'EducationCoursesAnalytic' }"
            ).mb-2
              v-icon(left) mdi-poll
              span Статистика
            div: v-btn(
              color="secondary"
              depressed
              :to="{ name: 'Teaching' }"
            )
              v-icon(left) mdi-forum
              span Консультации и задания
      v-col(cols=12 md=8)
        nearest-translations
      v-col(cols=12)
        v-card(
          text
        ).sdo-shadow.sdo-radius
          v-card-text.pa-5
            .d-flex
              div
                h3 Я куратор
                p Курсы, где я назначен куратором
              //- v-spacer
              //- v-btn(
              //-   color="secondary lighten-1"
              //-   depressed
              //-   rounded
              //-   :to="{ name: 'Supervision' }"
              //- ).mr-5 Курирование курсов
              //- tooltip-wrap(
              //-   text="Создать курс"
              //- )
              //-   v-btn.ml-2(
              //-     color="secondary" fab outlined small
              //-     :to="{ name: 'CourseCreate' }"
              //-   )
              //-     v-icon mdi-plus

            v-row
              v-col(v-if="!courses.length")
                .caption Курсы не найдены.
                  |  Дождитесь пока вас назначит организация, либо создайте свой курс
              v-col(
                xl="3" lg="4" md="6" cols="12"
                v-for="(course, i) in courses"
                :key="course.id"
              )
                course-card(
                  :course="course"
                  outlined
                  editable
                  curator
                )

</template>

<script>
import { STATUSES } from '@/modules/CourseManagement/constants';

import CourseListFilterBlock from '@/modules/Courses/components/CourseListFilterBlock.vue';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';
import NearestTranslations from './Widgets/NearestTranslations.vue';

export default {
  name: 'DesktopTeacher',
  components: {
    CourseCard,
    CourseListFilterBlock,
    NearestTranslations,
  },
  data: () => ({
    tab: 0,
    courses: [],

    STATUSES,

    TABS: {
      teach: 'teach',
      study: 'study',
    },
  }),
  created() {
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      const params = {
        expand: '',
      };
      // params['search[course_authors]'] = this.$user.data.id;

      // if (this.tab === this.TABS.teach) {
      //   params['search[course_authors]'] = this.$user.data.id;
      // } else {
      //   params['search[trained]'] = true;
      //   params.expand += 'priority_user_prior_record,';
      // }

      params.expand += 'organizations,lessons,edit,type_activity_name,course_units_count';

      this.$loader.start({ target: true });
      this.courses = [];
      const { items } = await this.$api.courses.index(
        params,
        this.$conf.COURSE_SERVICE.supervisor,
      );
      this.courses = items;
      this.$loader.stop();
    },
    routeToCourses(query = {}) {
      this.$router.push({ name: 'CourseList', query });
    },
  },
};
</script>
